import { render, staticRenderFns } from "./CustomerStatusSearch.vue?vue&type=template&id=c6226a58&"
import script from "./CustomerStatusSearch.vue?vue&type=script&lang=js&"
export * from "./CustomerStatusSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports